var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"produce"},[_c('div',{staticClass:"lead"},[_c('div',{staticClass:"lead-input -bar"}),_c('p',{ref:"textLead",staticClass:"lead-text -f-grid-condensed"},[_vm._v("CHICKEN")])])])}
var staticRenderFns = []

export { render, staticRenderFns }